import {isNil} from 'ramda';

import {Nullish} from 'shared/web';

const HTML_TAG_START_REGEX = /^\s*(?:<[!/]?[a-zA-Z][a-zA-Z0-9]*[\s>\/]|<!--)/;
const PARAGRAPH_SPLIT_REGEX = /\n{2,}/;
const CRLF_REGEX = /\r\n?/g;

export function ensureHTML(value: string | Nullish) {
  if (isNil(value)) {
    return '';
  }

  const normalized = value.replace(CRLF_REGEX, '\n');

  if (HTML_TAG_START_REGEX.test(normalized)) {
    return normalized;
  }

  return normalized
    .split(PARAGRAPH_SPLIT_REGEX)
    .filter((paragraph) => paragraph.length > 0)
    .map((paragraph) => {
      return `<p>${escapeHTML(paragraph).replace(/\n/g, '<br>')}</p>`;
    })
    .join('');
}

function escapeHTML(value: string) {
  return value
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}
